module.exports = __webpack_public_path__ + "static/media/SL.780f1ed6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SL.svg
// module id = 2261
// module chunks = 7